<template>
  <div class="genre-tags">
    <TagItem
      v-for="(list, index) in content"
      :key="index"
      :href="category[index] && category[index][locale] ? '#'+category[index][locale].name : ''"
      large
    >
      {{ category[index] && category[index][locale] ? category[index][locale].name : '' }}
      ({{ Object.keys(list).length }})
    </TagItem>
  </div>
</template>

<script>
import TagItem from '@/components/common/TagItem'

export default {
  components: {
    TagItem
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    locale: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.genre-tags{
  margin: 0 0 24px;
  .tag-item {
    padding: 8px 24px;
    margin: 12px 16px 12px 0;
  }
}

@media only screen and (max-width: 1439.98px) {
  .genre-tags{
    .tag-item{
        margin: 12px 10px 12px 0;
        font-size: 16px;
        font-weight: bold;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .genre-tags{
    display: none;
  }
}
</style>
